import { useEffect, useState } from "react";
import { Loader2, Lock, User } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { getInvitation, acceptInvitation, setAuthToken } from "@/lib/dentiumApi";

const errMsg = (e, fallback) => (typeof e?.response?.data?.detail === "string" ? e.response.data.detail : fallback);

export const AcceptInvite = ({ onAuthed }) => {
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getInvitation(token).then(setInvite).catch((e) => setError(errMsg(e, "La invitación no es válida")));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return setError("La contraseña debe tener al menos 8 caracteres");
    setLoading(true);
    setError("");
    try {
      const d = await acceptInvitation(token, { name: name.trim(), password });
      setAuthToken(d.access_token);
      window.history.replaceState({}, "", "/");
      onAuthed(d.user);
    } catch (err) {
      setError(errMsg(err, "No se pudo completar el registro"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-4">
      <div className="w-full max-w-[420px] bg-white rounded-3xl p-8 shadow-2xl" data-testid="accept-invite-page">
        <h1 className="font-display text-2xl font-normal text-[#1A1A1A] text-center">Únete al equipo</h1>
        <p className="text-sm text-[#8A7E70] text-center mt-1.5 mb-7" data-testid="invite-info">
          {invite ? `${invite.clinic_name} te ha invitado (${invite.email})` : error ? "" : "Comprobando invitación…"}
        </p>
        {invite && (
          <form onSubmit={submit} className="space-y-4">
            <div className="relative">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#A79E90]" />
              <Input data-testid="invite-name-input" required value={name} onChange={(e) => setName(e.target.value)} placeholder="Nombre y apellidos" className="pl-9 h-11" />
            </div>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#A79E90]" />
              <Input data-testid="invite-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Contraseña (mín. 8 caracteres)" className="pl-9 h-11" />
            </div>
            <Button data-testid="invite-accept-btn" type="submit" disabled={loading} className="w-full h-11 bg-[#1A1A1A] hover:bg-black text-white">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Crear mi acceso"}
            </Button>
          </form>
        )}
        {error && <div data-testid="invite-error" className="mt-4 text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-3 py-2">{error}</div>}
        {error && !invite && <a href="/" data-testid="invite-go-login" className="block text-center text-sm text-[#1A1A1A] underline mt-4">Ir al inicio de sesión</a>}
      </div>
    </div>
  );
};
